<template>
  <div>
    <Navbar />
    <Sidenav :isMobile="isMobile" :token="token"></Sidenav>
    <div class="content d-flex flex-column justify-content-between">
      <ContentHeader :page_name="$route.name" />
      <div class="mb-auto">
        <router-view
          :key="$route.fullPath"
          :isMobile="isMobile"
          :token="token"
        ></router-view>
      </div>
      <div class="content-footer py-4 bg-white">
        <div class="content-width">
          <div class="d-flex justify-content-between">
            <small class="text-platform_sub"
              >© {{ new Date().getFullYear() }} Quarter Car
              Part.版權所有。</small
            >
            <small class="text-platform_sub">v{{ version }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.content {
  width: calc(100% - #{$sidenav_width});
  min-height: 100vh;
  margin-left: auto;
  padding-top: $navbar_height;
  background: #f2f2f2;
  @include media-breakpoint-down(sm) {
    padding-top: $navbar_height-sm;
    width: 100%;
  }
}
</style>

<script>
import Sidenav from "@/components/manage/Sidenav.vue";
import Navbar from "@/components/manage/Navbar.vue";
import ContentHeader from "@/components/manage/ContentHeader.vue";

export default {
  name: "Manage",
  components: {
    Sidenav,
    Navbar,
    ContentHeader
  },
  data() {
    return {
      isMobile: false,
      token: null,
      version: process.env.VUE_APP_VERSION
    };
  },
  created() {
    this.token = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("manage-api_token")
      }
    };
  },
  methods: {
    resizeWindowWidth() {
      if (window.innerWidth < 767.98) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  mounted() {
    this.resizeWindowWidth();
    window.addEventListener("resize", () =>
      setTimeout(() => {
        this.resizeWindowWidth();
      }, 100)
    );
  }
};
</script>
